import { Delete, Edit, Save } from '@mui/icons-material';
import { Button, Paper } from '@mui/material';
import { WidgetConfig } from './widget';

interface WidgetEditControlsProps {
  widget: WidgetConfig;
  onEdit: (widget: WidgetConfig) => void;
  onRemove: (widgetId: string) => void;
  onSave?: (widget: WidgetConfig) => void;
  isVisible: boolean;
  hasUnsavedChanges?: boolean;
}

export const WidgetEditControls = ({
  widget,
  onEdit,
  onRemove,
  onSave,
  isVisible,
  hasUnsavedChanges = false,
}: WidgetEditControlsProps) => {
  if (!isVisible) return null;

  return (
    <Paper
      // elevation={3}
      sx={{
        // position: 'absolute',
        // top: 0,
        // left: 0,
        // right: 0,
        bgcolor: 'background.paper',
        // opacity: 0.5,
        borderBottom: 0.2,
        borderColor: 'divider',
        boxShadow: 'none',
        p: 1,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        zIndex: 1,
        borderRadius: 0,
      }}
    // className="widget-edit-controls"
    >
      {hasUnsavedChanges && onSave && (
        <Button
          onClick={() => onSave(widget)}
          size="small"
          color="primary"
          variant="outlined"
          sx={{ mr: 1 }}
          startIcon={<Save />}
        >
          Save
        </Button>
      )}
      <Button
        onClick={() => onEdit(widget)}
        size="small"
        color="primary"
        variant="outlined"
        sx={{ mr: 1 }}
        startIcon={<Edit />}
      >
        Edit
      </Button>
      <Button
        onClick={() => onRemove(widget.id)}
        size="small"
        variant="outlined"
        color="primary"
        startIcon={<Delete />}
      >
        Delete
      </Button>
    </Paper>
  );
};
